import BaseApi from '../base/base'
import CourseLesson from '../../models/course_lesson'

export default class CourseLessonApi extends BaseApi {
  constructor() {
    super()
    this.path = '/courses'
  }

  async index(params = { courseId: '0', mode: 'all' }) {
    this.path = `/courses/${params.courseId}/course_lessons`
    const response = await this.getRequest(params)
    return response.data.map((element) => {
      return new CourseLesson(element)
    })
  }

  async show(params = { courseId: '0', id: 0 }) {
    this.path = `/courses/${params.courseId}/course_lessons/${params.id}`
    const response = await this.getRequest(params)
    return new CourseLesson(response.data)
  }
}
